const cookies = {
  message: `<div align="justify">
  <p>
    <b>GLOSPEN, SL</b> utiliza
    <b>
      <i>&quot;COOKIES&quot;</i>
    </b> para garantizar el correcto funcionamiento de nuestro portal
    web, mejorando la seguridad, para obtener una eficacia y una personalización superiores, para
    recoger datos estadísticos y para mostrarle publicidad relevante.
  </p>
  <p>
    Si continúa navegando o pulsa el botón
    <b>&quot;ACEPTAR&quot;</b> consideraremos que acepta todo su uso.
    Puede obtener más información en nuestra
    <a
      href="/cookies/es"
      target="_blank"
    >POLÍTICA DE COOKIES</a> en el pie de página.
  </p>
</div>`,
  content: `<ol>
  <div>
    <li class="body-2 font-weight-bold pb-2">¿QUE SON LAS COOKIES?</li>
    <p style="text-align: justify" class="body-1">
      Las cookies son pequeños archivos de datos que se reciben en el terminal desde el sitio web
      visitado y se usan para registrar ciertas interacciones de la navegación en un sitio web
      almacenando datos que podrán ser actualizados y recuperados. Estos archivos se almacenan
      en el ordenador del usuario y contiene datos anónimos que no son perjudiciales para su
      equipo. Se utilizan para recordar las preferencias del usuario, como el idioma seleccionado,
      datos de acceso o personalización de la página.
    </p>
    <p style="text-align: justify" class="body-1">
      Las cookies también pueden ser utilizadas para registrar información anónima sobre cómo un
      visitante utiliza un sitio. Por ejemplo, desde qué página web ha accedido, o si ha utilizado un
      &quot;banner&quot; publicitario para llegar.
    </p>
  </div>
  <div>
    <li class="body-2 font-weight-bold pb-2">¿POR QUE UTILIZAMOS COOKIES?</li>
    <p style="text-align: justify" class="body-1">
      <b>GLOSPEN, SL</b> utiliza cookies estrictamente necesarias y esenciales para que utilice nuestros
      sitios web y le permitan moverse libremente, utilizar áreas seguras, opciones personalizadas,
      etc. Además,
      <b>GLOSPEN, SL</b> utiliza cookies que recogen datos relativos al análisis de uso de la
      web. Estas se utilizan para ayudar a mejorar el servicio al cliente, midiendo el uso y el
      rendimiento de la página, para optimizarla y personalizarla.
    </p>
    <p style="text-align: justify" class="body-1">
      Nuestros sitios también pueden tener enlaces de redes sociales (como Facebook o Twitter).
      <b>GLOSPEN, SL</b> no controla las cookies utilizadas por estas webs externas. Para más
      información sobre las cookies de las redes sociales u otras Webs ajenas, aconsejamos revisar
      sus propias políticas de cookies.
    </p>
    <p
      style="text-align: justify"
      class="body-1"
    >Este sitio web utiliza &quot;cookies&quot; de la siguiente manera:</p>
    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <b>Cookie de Google ANALYTICS:</b> Google ANALYTICS es un servicio gratuito que ofrece
        Google Inc. y que recoge información sobre las páginas de la web consultada, a qué hora, qué
        navegador Web, etc. Posteriormente, esta información se envía a los servidores de Google Inc.
        en Estados Unidos.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies de aplicación &quot;Add-this&quot;:</b> Add-this es un servicio gratuito que le permite compartir
        páginas de este sitio web por diferentes medios (correo electrónico, redes sociales, etc.). Add-
        his recoge información estadística de su navegación para proporcionar publicidad adaptada a
        sus hábitos de navegación en este sitio web o en cualquier otro lugar.
      </li>
    </ul>
  </div>
  <div>
    <li
      class="body-2 font-weight-bold pb-2"
    >¿QUE USO LE DAMOS A LOS DIFERENTES TIPOS DE COOKIES?</li>
    <div class="body-2 font-weight-bold pb-2">Según su finalidad:</div>
    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <b>Cookies técnicas:</b> Las cookies técnicas son aquellas imprescindibles y estrictamente
        necesarias para el correcto funcionamiento de un portal web y la utilización de las diferentes
        opciones y servicios que ofrece. Por ejemplo, las que sirven para el mantenimiento de la
        sesión, la gestión del tiempo de respuesta, rendimiento o validación de opciones, utilizar
        elementos de seguridad, compartir contenido con redes sociales, etc.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies de personalización:</b> Estas cookies permiten al usuario especificar o personalizar
        algunas características de las opciones generales de la página web, por ejemplo, definir el
        idioma, configuración regional o tipo de navegador.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies analíticas:</b> Las cookies analíticas son las utilizadas por nuestro portal web, para
        elaborar perfiles navegación y poder conocer las preferencias de los usuarios del mismo con el
        fin de mejorar la oferta de productos y servicios. Por ejemplo, mediante una cookie analítica se
        controlarían las áreas geográficas de mayor interés de un usuario, cuál es el producto de más
        aceptación, etc.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies publicitarias/de publicidad:</b> Las cookies publicitarias permiten la gestión de los
        espacios publicitarios en base a criterios concretos. Por ejemplo, la frecuencia de acceso, el
        contenido editado, etc. Las cookies de publicidad permiten a través de la gestión de la
        publicidad almacenar información del comportamiento a través de la observación de hábitos,
        estudiando los accesos y formando un perfil de preferencias del usuario, para ofrecer
        publicidad relacionada con los intereses de su perfil.
      </li>
    </ul>
    <div class="body-2 font-weight-bold pb-2">Según plazo:</div>
    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <b>Cookies de sesión:</b> Las cookies de sesión son aquellas que duran el tiempo que el usuario
        está navegando por la página web y se borran al término.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies persistentes:</b> Estas cookies quedan almacenadas en el terminal del usuario, por un
        tiempo más largo, facilitando así el control de las preferencias elegidas sin tener que repetir
        ciertos parámetros cada vez que se visite el sitio web.
      </li>
    </ul>
  </div>
  <div>
    <li
      class="body-2 font-weight-bold pb-2"
    >¿Y SI NO QUIERO TENER ESTAS COOKIES O NO HAGO NADA AL RESPECTO?</li>
    <p style="text-align: justify" class="body-1">
      Para cumplir con la legislación vigente, tenemos que pedir su permiso para gestionar cookies.
      Si decide no autorizar el tratamiento indicando la no conformidad, sólo utilizaríamos las cookies
      técnicas, ya que son imprescindibles para la navegación por nuestra web. En este caso, no se
      almacena ninguna cookie. En el caso de seguir navegando por nuestro sitio web sin denegar
      su autorización implica que acepta su uso.
    </p>
    <p style="text-align: justify" class="body-1">
      Tenga en cuenta que si rechaza o borra las cookies de navegación por la Web, no podremos
      mantener sus preferencias, algunas características de las páginas no estarán operativas, no
      podremos ofrecerle servicios personalizados y cada vez que vaya a navegar por nuestra web
      tendremos que solicitar de nuevo su autorización para el uso de cookies.
    </p>
    <p style="text-align: justify" class="body-1">
      Si aún así, decide modificar la configuración de su acceso a la página web, debe saber que es
      posible eliminar las cookies o impedir que se registre esta información en su equipo en
      cualquier momento mediante la modificación de los parámetros de configuración de su
      navegador:
    </p>

    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"
        >Configuración de cookies de Internet Explorer.</a>
      </li>
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
        >Configuración de cookies de Firefox.</a>
      </li>
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=es-419"
        >Configuración de cookies de Google Chrome.</a>
      </li>
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
        >Configuración de cookies de Safari.</a>
      </li>
    </ul>
    <p style="text-align: justify" class="body-1">
      Estos navegadores están sometidos a cambios o modificaciones, por lo que no podemos
      garantizar que se ajusten completamente a la versión de su navegador. También puede ser
      que utilice otro navegador no contemplado en estos enlaces como Konqueror, Arora, Flock, etc.
      Para evitar estos desajustes, puede acceder directamente desde las opciones de su navegador
      que se encuentra generalmente en el menú de Opciones, en la sección de &quot;Privacidad&quot;. (Por
      favor, consulte la ayuda de su navegador para más información.)
    </p>
  </div>
  <div>
    <li class="body-2 font-weight-bold pb-2">¿DONDE PUEDO OBTENER MÁS INFORMACION?</li>
    <p
      style="text-align: justify"
      class="body-1"
    >Puedes encontrar más información sobre cookies en:</p>

    <a target="_blank" href="https://www.allaboutcookies.org">www.allaboutcookies.org</a> o
    <a
      target="_blank"
      href="https://www.youronlinechoices.eu"
    >www.youronlinechoices.eu.</a>
  </div>
</ol>`,
}
export default cookies
